import * as React from 'react';

interface LabelProps {
  children: React.ReactNode | React.ReactNode[];
}

const Label = ({ children }: LabelProps) => {
  return <h6 className="br-section-label">{children}</h6>;
};

export default Label;
